import { AssetManager } from "./asset-manager";

export type PreloadPriority = "CRITICAL" | "UPGRADE" | "PREFETCH";

const priorityOrder: Record<PreloadPriority, number> = {
  CRITICAL: 0,
  UPGRADE: 1,
  PREFETCH: 2,
};

export class PreloadQueue {
  private readonly entries: Array<{ url: string; priority: PreloadPriority }> = [];

  constructor(private readonly assets: AssetManager) {}

  enqueue(url: string, priority: PreloadPriority): void {
    if (this.entries.some((entry) => entry.url === url)) return;
    this.entries.push({ url, priority });
    this.entries.sort((a, b) => priorityOrder[a.priority] - priorityOrder[b.priority]);
  }

  async drain(): Promise<void> {
    while (this.entries.length > 0) {
      const entry = this.entries.shift();
      if (!entry) return;
      try {
        await this.assets.preloadImage(entry.url);
      } catch {
        // A failed non-critical prefetch should not interrupt the home experience.
      }
    }
  }
}
